<template>
    <div class="company-policy">
        <b-card :title="$translate('company_policy')" class="inner-page p-3">
            <b-overlay :show="updating" rounded="sm">
                <b-card-body>
                    <b-row>
                        <b-col cols="12" md="12">
                            <label class="mb-3 mt-3"><strong>{{ $translate('terms_of_service') }}</strong>
                            </label>
                            <b-form-input v-model="formData.terms_of_service" :placeholder="$translate('document_url')"></b-form-input>
                        </b-col>
                        <b-col cols="12" md="12">
                            <label class="mb-3 mt-3"><strong>{{ $translate('privacy_policy') }}</strong> </label>
                            <b-form-input v-model="formData.privacy_policy" :placeholder="$translate('document_url')"></b-form-input>
                        </b-col>
                        <div class="text-center">
                            <button variant="primary" class="btn btn btn-info btn-fw mt-3 me-2 btn-primary"
                                v-if="hasPermissionUpdate" @click="updateSettings" size="sm">
                                <b-spinner small v-if="updating" :label="$translate('loading')"></b-spinner>
                                <span v-else>{{ $updateLabel() }}</span>
                            </button>
                        </div>
                    </b-row>
                </b-card-body>
            </b-overlay>
        </b-card>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'companyPolicy',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        formData: {
            terms_of_service: null,
            privacy_policy: null,
        },
        updating: false
    }),

    computed: {
        componentName() { return this.$translate('company_policy') },
        companyPolicyValue() {
            const companyPolicy = this.$store.getters['company/companyPolicyValue']
            return companyPolicy
        },
        companyPolicyKey() {
            return this.$store.state.company.settingKeys.companyPolicyKey
        },
    },
    watch: {
        companyPolicy: {
            handler: function (val) {
                this.updateModel(val)
            },
            deep: true,
        },
    },
    async mounted() {
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.companyPolicyKey
        )
        this.$nextTick(() => {
            this.updateModel(this.companyPolicyValue)
        })
    },

    methods: {
        updateModel(companyPolicyValue) {
            const value = { ...(companyPolicyValue || {}) }
            this.$set(this.formData, 'terms_of_service', value.terms_of_service)
            this.$set(this.formData, 'privacy_policy', value.privacy_policy)
        },
        async updateSettings() {
            try {
                this.updating = true
                const urlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
                let PrivacyValid = true
                let TermsValid = true
                if (this.formData.terms_of_service !== '') {
                    PrivacyValid = urlRegex.test(this.formData.terms_of_service);
                }
                if (this.formData.privacy_policy !== '') {
                    TermsValid = urlRegex.test(this.formData.privacy_policy);
                }
                if (!PrivacyValid || !TermsValid) {
                    throw new Error(this.$translate("enter_valid_url"))
                }
                const text_value = JSON.stringify(this.formData)
                const bool_value = false
                await this.$store.dispatch('company/updateConfiguration', {
                    key: this.companyPolicyKey,
                    text_value,
                    bool_value,
                })
                this.genericToast(this.componentName, this.$translate('updated'), 'success', `${this.componentName} ${this.$translate('update_alert')}`)
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>
